import { useDispatch } from 'react-redux';
import { Button } from '@/components/ui/button';
import { useRef } from 'react';
import { Input } from '@/components/ui/input';
import { IconComponent } from '../../../util/icons';
import CopyContent from '../../../asset/icons/copy-content.svg';
import { showAlert } from '../../../slice/AlertSlice';
import { Variants } from '@/types/common';
import { Typography } from '@/components/ui/typography';

interface ZillowAssetsProps {
  zillow3d: string;
}

const ZillowAssets = ({ zillow3d }: ZillowAssetsProps) => {
  const dispatch = useDispatch();
  const zillow3dNonBrandedRef = useRef<HTMLInputElement | null>(null);

  const actionNonBrandedView = () => {
    if (zillow3dNonBrandedRef?.current) {
      navigator.clipboard.writeText(zillow3dNonBrandedRef.current.value);
      dispatch(
        showAlert({
          type: Variants.SUCCESS,
          message: 'Copied'
        })
      );
    }
  };

  const openZillow3dURL = () => {
    if (zillow3dNonBrandedRef?.current) {
      window.open(
        zillow3dNonBrandedRef?.current.value,
        '_blank',
        'noopener,noreferrer'
      );
    }
  };

  return (
    <div className="border border-border rounded-lg bg-card h-[450px]">
      <div className="flex flex-col gap-1 rounded-t-lg bg-card">
        <div className="border-b border-border p-6">
          <Typography className="text-lg font-medium">
            Please find your Zillow 3D Tour URL below.
          </Typography>
        </div>
        <div className="p-6">
          <div className="flex flex-col gap-1">
            <Typography variant="heading-md">
              Zillow 3D Tour Link
            </Typography>
            <div className="flex items-center gap-1">
              <Input
                id="zillow3dnonbranded"
                name="zillow3dnonbranded"
                type="text"
                aria-describedby="zillow3dnonbranded"
                value={zillow3d}
                ref={zillow3dNonBrandedRef}
                data-testid="zillow3dnonbranded_id"
                className="text-info"
                readOnly
              />
              <Button
                type="button"
                variant="link"
                onClick={() => actionNonBrandedView()}
              >
                <IconComponent src={CopyContent} alt="download" />
              </Button>
              <Button
                type="button"
                variant="outline"
                className="h-10 w-[140px] font-medium"
                onClick={() => openZillow3dURL()}
              >
                View
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZillowAssets;
